"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_WIDGET_CHANNEL = void 0;
exports.CHAT_WIDGET_CHANNEL = "chat-widget";
//# sourceMappingURL=Constants.js.map